import type { ReactNode } from "react";
import Icon from "~/components/shared/Icon";

export default function Wrapper({
  title,
  icon,
  children,
}: {
  title: string;
  icon: string;
  children: ReactNode;
}) {
  return (
    <div className="flex items-baseline gap-2">
      <dt>
        <Icon aria-label={title} className="h-4 w-4 text-gray-700" icon={icon} title={title} />
      </dt>
      <dd>{children}</dd>
    </div>
  );
}
